//
// TextLengthFieldOptions
//
// Field options 'min_length' and 'max_length'

import { observer } from 'mobx-react-lite'
import { useStore } from '../../../../stores'

import { TextInput } from '../../../../components'
import { LabeledField } from '../../../components'

import { duckField, validateField } from '../../../../stores/data/validators'
import { VALIDATION } from '../../../../utils/validation'

export const TextLengthFieldOptions = observer(function TextLengthFieldOptions({
    field,
    selectModified,
    worksheet,
    onAction,
    setSelected,
    renderkeyprefix,
}) {
    const { app } = useStore()

    if (!field) return null
    const min_length = field.options.get('min_length')
    const max_length = field.options.get('max_length')

    const onChangeFieldOption = option => {
        return event => {
            field.setOption(option, event.target.value)
        }
    }
    const onBlurFieldOption = (option, validator) => {
        return event => {
            if (validator(event.target.value, field).result === VALIDATION.ERROR) {
                // TODO: CC-204 resetOption
            } else {
                field.setOption(option, event.target.value.trim())
                field.commitIfModified().then(result => selectModified(result))
            }
        }
    }

    const duckMinField = duckField('number', { max: max_length }) // min < max
    const minValidator = fieldvalue => {
        return validateField(fieldvalue, duckMinField, worksheet.language)
    }
    const onChangeFieldMin = onChangeFieldOption('min_length')
    const onBlurFieldMin = onBlurFieldOption('min_length', minValidator)

    const duckMaxField = duckField('number', { min: min_length }) // max > min
    const maxValidator = fieldvalue => {
        return validateField(fieldvalue, duckMaxField, worksheet.language)
    }
    const onChangeFieldMax = onChangeFieldOption('max_length')
    const onBlurFieldMax = onBlurFieldOption('max_length', maxValidator)

    return (
        <>
            <LabeledField label={app.text('min length')}>
                <TextInput
                    onChange={onChangeFieldMin}
                    onBlur={onBlurFieldMin}
                    value={min_length}
                    renderkey={renderkeyprefix + '.min_length'}
                    validate={minValidator}
                />
            </LabeledField>
            <LabeledField label={app.text('max length')}>
                <TextInput
                    onChange={onChangeFieldMax}
                    onBlur={onBlurFieldMax}
                    value={max_length}
                    renderkey={renderkeyprefix + '.max_length'}
                    validate={maxValidator}
                />
            </LabeledField>
        </>
    )
})
